import { Box, Stack, Typography } from "@mui/material"
import { OreveChipInfo } from "components/OreveChip"
import { useSessionsContext } from "layouts/sessions/context/sessions-context"
import {
    BatterySessionIcon,
    EuroSessionIcon,
    FlashSessionIcon,
} from "layouts/sessions/utils/icons"
import { useMemo } from "react"

export const SessionsHeader = () => {
    const { filteredSessions } = useSessionsContext()
    const totalFilteredSessionsPrice = useMemo(() => {
        return filteredSessions.reduce((acc, cur) => acc + (cur.price || 0), 0).toFixed(2)
    }, [filteredSessions])
    const totalFilteredSessionsKwh = useMemo(() => {
        return filteredSessions.reduce((acc, cur) => acc + (cur.kwh || 0), 0).toFixed(3)
    }, [filteredSessions])
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <Typography variant="headlineLarge" sx={{ color: "grey.900" }}>
                Recharges
            </Typography>
            <Stack direction="row" justifyContent="space-between" gap="0.5rem">
                <OreveChipInfo
                    icon={<EuroSessionIcon />}
                    label={`${totalFilteredSessionsPrice} €`}
                />
                <OreveChipInfo
                    icon={<FlashSessionIcon />}
                    label={`${totalFilteredSessionsKwh} kWh`}
                />
                <OreveChipInfo
                    icon={<BatterySessionIcon />}
                    label={`${filteredSessions.length} sessions de recharge`}
                />
            </Stack>
        </Box>
    )
}
